if (!customElements.get('featured-collections')) {
  class FeaturedCollections extends HTMLElement {
    constructor() {
      super();
  
      this.selectors = {
        collection: '[data-collection]',
        currentTitle: '[data-current-title]',
        header: '[data-header]',
        headerMobile: '[data-header-mobile]',
        menuItem: '[data-menu-item]',
        menuListItem: '[data-menu-list-item]',
        product: '[data-product]',
        showMore: '[data-show-more]',
        title: '[data-title]'  
      }
  
      this.classes = {
        active: 'active',
        hidden: 'hide'
      }
      
      this.data = {
        id: 'id'
      }
  
      this.mqlMobile = window.matchMedia('screen and (max-width: 749px)')
  
      this.collections = [...this.querySelectorAll(this.selectors.collection)];
      this.currentTitle = this.querySelector(this.selectors.currentTitle);
      this.headers = this.querySelectorAll(this.selectors.header);
      this.headerMobile = this.querySelector(this.selectors.headerMobile);
      this.menuItems = this.querySelectorAll(this.selectors.menuItem);
      this.menuListItems = this.querySelectorAll(this.selectors.menuListItem);
      this.showMores = this.querySelectorAll(this.selectors.showMore);
      this.titles = this.querySelectorAll(this.selectors.title);
      
      this.initEvents();
      
    }
    
    initEvents() {
      [...this.menuItems, ...this.menuListItems].forEach(mi => mi.addEventListener('click', this.goToCollection.bind(this)));
      this.showMores.forEach(sm => sm.addEventListener('click', this.showAllProducts.bind(this)));
      window.addEventListener('scroll', this.throttle(this.onScroll, 50), { passive: true });
    }
  
    goToCollection(e) {
      const target = e.currentTarget;
      const id = target.dataset[this.data.id];
      const collection = this.collections.find(c => c.dataset[this.data.id] == id);
      const top = collection.getBoundingClientRect().top + window.pageYOffset - 150;
  
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
      
    }
    
    showAllProducts(e) {
      e.preventDefault();
      const target = e.currentTarget;
      const products = target.closest(this.selectors.collection).querySelectorAll(this.selectors.product);
  
      products.forEach(p => p.classList.remove(this.classes.hidden));
      target.parentNode.classList.add(this.classes.hidden);
    }
  
    onScroll = () => {
      this.toggleHeaderMobile();
      this.switchContent();
    }
  
    toggleHeaderMobile() {
      if (!this.mqlMobile.matches) return;
  
      let dims = this.getBoundingClientRect();
  
      this.headerMobile.classList.toggle(this.classes.active, dims.top < 0 && dims.bottom - 100 > 0);
    }
  
    switchContent() {
      let highestPercentage = 0;
      let activeCollection;
  
      this.collections.forEach(collection => {
        let percentageWithinViewport = this.percentageWithinViewport(collection);
  
        if (percentageWithinViewport > highestPercentage) {
          highestPercentage = percentageWithinViewport;
          activeCollection = collection;       
        }
      })
  
      if (!highestPercentage) {
        this.disableActiveMenuItems();
      } else {
        const id = activeCollection.dataset[this.data.id];
        if (
          !this.currentActiveId || 
          this.currentActiveId !== id
        ) {
          this.currentActiveId = id;
          this.switchTitle(id);
          this.setActiveMenuItem(id);
          this.setActiveMenuListItem(id);
        }
      }
    }
  
    switchTitle(id) {
      this.titles.forEach(t => {
        if (t.dataset[this.data.id] === id) {
          t.classList.remove(this.classes.hidden);
        } else {
          t.classList.add(this.classes.hidden);
        }
      });
    }
    
    disableActiveMenuItems() {
      this.menuItems.forEach(mi => mi.classList.remove(this.classes.active));
    }
  
    setActiveMenuItem(id) {
      this.menuItems.forEach(mi => {
        if (mi.dataset[this.data.id] === id) {
          mi.classList.add(this.classes.active);
        } else {
          mi.classList.remove(this.classes.active); 
        }
      }); 
    }
  
    setActiveMenuListItem(id) {
      let currentTitle;
      
      this.menuListItems.forEach(mli => {
        if (mli.dataset[this.data.id] === id) {
          mli.parentNode.classList.add(this.classes.hidden);
          currentTitle = mli.textContent;
        } else {
          mli.parentNode.classList.remove(this.classes.hidden); 
        }
      });
      
      this.currentTitle.innerText = currentTitle;
    }
  
    percentageWithinViewport(element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const spaceTop = elementTop - scrollTop;
      const elementHeight = element.offsetHeight;
      const screenHeight = window.innerHeight;
      const scrollBottom = scrollTop + screenHeight;
      const bottomElement = elementTop + elementHeight;
      const spaceBottom = bottomElement - scrollBottom;
      let heightInScreen = elementHeight - spaceBottom;
      let percentage;
  
      if (spaceTop < 0) {
          heightInScreen -= spaceTop * -1;
      }
  
      if (spaceBottom < 0) {
          heightInScreen -= spaceBottom * -1;
      }
  
      percentage = heightInScreen / screenHeight * 100;
      percentage = percentage < 0 ? 0 : percentage;
  
      return percentage;
    }
  
    throttle(fn, delay) {
      let lastCall = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return fn(...args);
      };
    }
    
  }

  customElements.define('featured-collections', FeaturedCollections);
}
